<div class="page-content container">
  <div class="page-header">
    <h1>
      {{ translationManager.getTranslation('Администрација рола') }}
    </h1>
  </div>

  <div class="page-data shadow-sm">
    <div class="page-part">
      <div class="alert alert-info">
        <span *ngIf="state === viewState.Edit">
          <i class="fa fa-info-circle"></i>
          {{ translationManager.getTranslation('Страница за измену роле, молимо попуните потребне податке, сачувати промене притиском на дугме "Сачувај"') }}</span>
        <span *ngIf="state === viewState.Create">
          <i class="fa fa-info-circle"></i>
          {{ translationManager.getTranslation('Страница за додавање нове роле, молимо попуните потребне податке, сачувати промене притиском на дугме "Сачувај"') }}</span>
        <span *ngIf="state === viewState.Details">
          <i class="fa fa-info-circle"></i>
          {{ translationManager.getTranslation('Страница за детаљни приказ роле') }}</span>
      </div>
    </div>

    <div class="form-blocks">
      <div>
        <div class="content">
          <div class="form-element">
            <input type="hidden" name="id" [(ngModel)]="form.elements['id'].value">
          </div>

          <div class="page-part">
            <div class="form-element"
              [ngClass]="{ 'error': form.elements['name'].error.required || form.elements['name'].error.invalid }">
              <label>{{ translationManager.getTranslation('Назив') }}</label>
              <div class="content" *ngIf="state === viewState.Create || state === viewState.Edit">
                <input type="text" [(ngModel)]="form.elements['name'].value" maxlength="100">
              </div>
              <div class="content" *ngIf="state === viewState.Details">
                <div class="static">
                  <span>{{ form.elements['name'].value | appvalue }}</span>
                </div>
              </div>
              <div class="errors">
                <span *ngIf="form.elements['name'].error.required">
                  <i
                    class="fas fa-times-circle"></i>{{ translationManager.getTranslation('Поље је обавезно за унос') }}</span>
              </div>
            </div>
          </div>

          <div class="page-part">
            <div class="form-element"
              [ngClass]="{ 'error': form.elements['description'].error.required || form.elements['description'].error.invalid }">
              <label>{{ translationManager.getTranslation('Опис') }}</label>
              <div class="content" *ngIf="state === viewState.Create || state === viewState.Edit">
                <textarea [(ngModel)]="form.elements['description'].value" maxlength="200"></textarea>
              </div>
              <div class="content" *ngIf="state === viewState.Details">
                <div class="static">
                  <span>{{ form.elements['description'].value | appvalue }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="page-part">
            <div class="form-element" *ngIf="state === viewState.Details">
              <label>{{ translationManager.getTranslation('Креирао') }}</label>
              <div class="static">
                <span>{{ form.elements['createdByName'].value | appvalue }}</span>
              </div>
            </div>
          </div>

          <div class="page-part">
            <div class="form-element" *ngIf="state === viewState.Details">
              <label>{{ translationManager.getTranslation('Датум креирања') }}</label>
              <div class="static">
                <span>{{ form.elements['createdOn'].value | appdate | appvalue }}</span>
              </div>
            </div>
          </div>

          <div class="page-part">
            <div class="form-element" *ngIf="state === viewState.Details">
              <label>{{ translationManager.getTranslation('Изменио') }}</label>
              <div class="static">
                <span>{{ form.elements['updatedByName'].value | appvalue }}</span>
              </div>
            </div>
          </div>

          <div class="page-part">
            <div class="form-element" *ngIf="state === viewState.Details">
              <label>{{ translationManager.getTranslation('Датум измене') }}</label>
              <div class="static">
                <span>{{ form.elements['updatedOn'].value | appdate | appvalue }}</span>
              </div>
            </div>
          </div>

          <!-- <translation-entity #translationEntityRoleName [uniqueIdentifier]="'Role-Name'"></translation-entity> -->

          <div class="form-element-buttons">
            <button class="btn btn-warning fl" (click)="navigateToList()">
              <i class="fa fa-arrow-left mr-2"></i>{{ translationManager.getTranslation('Назад') }}</button>
            <button class="btn btn-success fr" (click)="submit()"
              *ngIf="state === viewState.Create || state === viewState.Edit">
              <i class="fa fa-check mr-2"></i>{{ translationManager.getTranslation('Сачувај') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
